var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('promotion-form',{on:{"completed":_vm.onCompleted}}),_c('promotion-list',{attrs:{"reload":_vm.reload},on:{"update:reload":function($event){_vm.reload=$event},"update":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }